import { createFileRoute } from '@tanstack/react-router'
import { FormattedMessage } from 'react-intl'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { TestIds } from '@/constants/testIds'

export const Route = createFileRoute('/terms')({
  component: Terms,
})

const ITEMS = [
  'termsOfUse.item1',
  'termsOfUse.item2',
  'termsOfUse.item3',
  'termsOfUse.item4',
  'termsOfUse.item5',
  'termsOfUse.item6',
  'termsOfUse.item7',
  'termsOfUse.item8',
  'termsOfUse.item9',
  'termsOfUse.item10',
  'termsOfUse.item11',
  'termsOfUse.item12',
  'termsOfUse.item13',
] as const

function Terms() {
  useDocumentTitle('meta.title.termsOfUse')

  return (
    <div className="max-w-3xl mx-auto px-6 py-8 text-sm text-gray-800">
      <h2
        data-testid={TestIds.terms.pageTitle}
        className="text-2xl font-bold mb-2"
      >
        <FormattedMessage id="termsOfUse.title" />
      </h2>
      <hr className="border-0 h-1 w-12 bg-red-600 mb-6" />

      <p className="font-bold mb-2">
        <FormattedMessage id="termsOfUse.pleaseRead" />
      </p>
      <p className="mb-4">
        <FormattedMessage id="termsOfUse.intro" />
      </p>

      <ol
        data-testid={TestIds.terms.termsList}
        className="list-decimal pl-5 space-y-3 mb-6"
      >
        {ITEMS.map((id) => (
          <li key={id}>
            <FormattedMessage id={id} />
          </li>
        ))}
      </ol>

      <p className="font-bold">
        <FormattedMessage id="termsOfUse.footer" />
      </p>
    </div>
  )
}
